<body>
    <div class="main" *ngIf="!errorStatus">
        <div class="head">Pay Now</div>
        <div class="info">
            <span class="feeSection">Registered Mobile No.</span>
            <span class="feeSection" style="text-align: right;display: flex;justify-content: flex-end;">{{mobile}}
                &nbsp;&nbsp;&nbsp;<svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
                    <path
                        d="M5.5 8.5H6.5V5.5H5.5V8.5ZM6 4.5C6.14167 4.5 6.2605 4.452 6.3565 4.356C6.4525 4.26 6.50033 4.14133 6.5 4C6.5 3.85833 6.452 3.7395 6.356 3.6435C6.26 3.5475 6.14133 3.49967 6 3.5C5.85833 3.5 5.7395 3.548 5.6435 3.644C5.5475 3.74 5.49967 3.85867 5.5 4C5.5 4.14167 5.548 4.2605 5.644 4.3565C5.74 4.4525 5.85867 4.50033 6 4.5ZM6 11C5.30833 11 4.65833 10.8687 4.05 10.606C3.44167 10.3433 2.9125 9.98717 2.4625 9.5375C2.0125 9.0875 1.65633 8.55833 1.394 7.95C1.13167 7.34167 1.00033 6.69167 1 6C1 5.30833 1.13133 4.65833 1.394 4.05C1.65667 3.44167 2.01283 2.9125 2.4625 2.4625C2.9125 2.0125 3.44167 1.65633 4.05 1.394C4.65833 1.13167 5.30833 1.00033 6 1C6.69167 1 7.34167 1.13133 7.95 1.394C8.55833 1.65667 9.0875 2.01283 9.5375 2.4625C9.9875 2.9125 10.3438 3.44167 10.6065 4.05C10.8692 4.65833 11.0003 5.30833 11 6C11 6.69167 10.8687 7.34167 10.606 7.95C10.3433 8.55833 9.98717 9.0875 9.5375 9.5375C9.0875 9.9875 8.55833 10.3438 7.95 10.6065C7.34167 10.8692 6.69167 11.0003 6 11ZM6 10C7.11667 10 8.0625 9.6125 8.8375 8.8375C9.6125 8.0625 10 7.11667 10 6C10 4.88333 9.6125 3.9375 8.8375 3.1625C8.0625 2.3875 7.11667 2 6 2C4.88333 2 3.9375 2.3875 3.1625 3.1625C2.3875 3.9375 2 4.88333 2 6C2 7.11667 2.3875 8.0625 3.1625 8.8375C3.9375 9.6125 4.88333 10 6 10Z"
                        fill="#1B6EBA" />
                </svg>
            </span>
        </div>
        <div class="fee">
            <label class="feeSection" for="">Pay Head</label>
            <mat-select class="feeSection form_select" placeholder="Select Fee Type" >
                <mat-option value="Fee" (click)="getDueAmount('FEE')">Fee</mat-option>
                <mat-option value="Akash Books" (click)="getDueAmount('AKASH_BOOKS')">Akash Books</mat-option>
                <!-- <mat-option value="Pocket Money" (click)="getDueAmount('POCMNY')">Pocket Money</mat-option> -->
            </mat-select>
        </div>
        <div class="fee">
            <label class="feeSection" for="">Overall Due (in Rs)</label>
            <input type="text" name="" id="" readonly class="dueinput" [value]="dueAmount">
        </div>
        <div class="fee">
            <label class="feeSection" for="">Payable Amount (In Rs)</label>
            <input type="text" style="padding-left: 10px;" class="feeSection form_select"
                placeholder="Please Enter Amount" (input)="getInputValue($event)" (input)="restrictToNumbers($event)">
        </div>
        <div class="btnContainer"><button class="submitButton" (click)="createOrder()">Pay Now</button></div>
    </div>
    <div *ngIf="errorStatus" class="error">
        <img src="../../../../assets/image/payment/nodatanew.png" alt="">
        <p style="word-wrap: normal; width: 60%;">{{message}}</p>
    </div>
</body>
<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>